import { Api, ModelRow, ModelSearchResult, StringUtil, MimeTypes, FileUtil } from "@mcleod/core";
import { AutogenLayoutRenditionBilling } from "./autogen/AutogenLayoutRenditionBilling";
import { Checkbox, DropdownItem, ClickEvent, DataDisplayEvent, Label, StepEvent, Textbox, DataSourceExecutionEvent, Layout, Panel, TableRowExpansionEvent, Button, HorizontalSpacer, ComponentCreator } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { ImageViewer } from "@mcleod/components";
import { RenditionMonitor } from "./RenditionMonitor";
import { LookupInvoice } from "./LookupInvoice";
import { RenditionPickList } from "./RenditionPickList";
import { ImageViewerValues } from "@mcleod/components";
import { ImgLic } from "./ImgLic";

let renlgxLicensed = false;

export class RenditionBilling extends AutogenLayoutRenditionBilling {
    private printOrder = 0;
    private printPages = 0;
    private emailOrder = 0;
    private emailPages = 0;
    private faxOrder = 0;
    private faxPages = 0;
    private ftpOrder = 0;
    private ftpPages = 0;
    private lgxOrder = 0;
    private lgxPages = 0;
    private errorOrder = 0;
    private errorPages = 0;
    private checkboxSelectAll: Checkbox;
    private reviewRows: ModelRow[] = [];
    private selectedPrinter = null;
    private procType = null;
    private fromPickList=false;

    override async onLoad() {
        this.sourceProcess.onTransformSearchResults = result => this.populateReviewData(result);
        this.checkboxSelectAll = new Checkbox({ height: 24 });
        //this.checkboxSelectAll.removeLabel();
        this.checkboxSelectAll.addChangeListener(() => this.toggleAll());
        const headingCell = this.tableRenditionBilling.columns[0]._headingCell;
        headingCell.removeAll();
        headingCell.paddingLeft = 0;
        headingCell.add(this.checkboxSelectAll);
        //default search, default orderby is set in the model
        //this.sourceRenditionBilling.orderBy = ["renb_load_no"],  ["renb_bill_to"], ["renb_invno" ];
        this.sourceRenditionBilling.search({ renb_done: "N", renb_submitted: "N", renb_billtype: "F|S|C" });
        this.sourceRenditionBilling.orderBy = [{field: "renb_invno", sort: "asc" },
                                                {field: "renb_bill_to", sort: "asc" },
                                                {field: "renb_load_no", sort: "asc" }];
        //get printers list
        this.sourceImgdev.search({ imdv_type: "P", imdv_port: "", imdv_comnt1: "" });
        this.sourceImgdev.orderBy = [{field: "imdv_port", sort: "asc" },
                                    {field: "imdv_comnt1", sort: "asc" }];

        renlgxLicensed = await ImgLic.renlgxLicensed();
        this.panelLgx.visible = renlgxLicensed;
    }

    private populateReviewData(result: ModelSearchResult): ModelSearchResult {
        for (let i = 0; i < this.reviewRows.length; i++) {
            const source = this.reviewRows[i];
            const target = result.modelRows[i];
            if( !target || !source )
                continue;
            target.set("renb_load_no", source.get("renb_load_no"));
            target.set("customer_name", source.get("customer_name"));
            target.set("delivery_methods", this.getDeliveryMethods(source, target));
            this.addMethodTotals(source, target);

            //view pick list file if any
            const fdataBase64 = target.get("fdata");
            const fpath = target.get("fpath");
            this.viewTifPdf( fdataBase64, fpath );
        }
        this.panelFax.visible = false;
        this.labelPrintSummary.text = this.printOrder + " / " + this.printPages;
        this.labelEmailSummary.text = this.emailOrder + " / " + this.emailPages;
        this.labelFaxSummary.text = this.faxOrder + " / " + this.faxPages;
        this.labelFtpSummary.text = this.ftpOrder + " / " + this.ftpPages;
        if( renlgxLicensed )
            this.labelLgxSummary.text = this.lgxOrder + " / " + this.lgxPages;
        this.labelErrorSummary.text = this.errorOrder + " / " + this.errorPages;
        if( result.modelRows[0] )
            this.labelJobNumber.text = result.modelRows[0].get("job");
        if( this.labelJobNumber.text == "-1" )
            this.buttonCommit.visible = false;
        else
            this.buttonCommit.visible = true;
        return result;
    }

    async viewTifPdf( fdataBase64: any, fpath: any )
    {
        this.fromPickList = false;
        if( fdataBase64.length > 10 )
        {
            const p: string = fpath;
            fpath = p.replace( /\\/g, "_" );
            if( fpath.endsWith(".tif") )
                fpath += "f";
            //const props = { height: "90%", width: "90%", panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } };
            if (ImageViewer.eligibleToView(fpath) === true)
            {
                const imageViewerValues: ImageViewerValues = new ImageViewerValues(fdataBase64, fpath, "Rendition Billing Viewer");
                ImageViewer.viewImage( imageViewerValues );
                //ImageViewer.viewImage( fdataBase64, fpath );
            }
            else
                this.viewPdf( fdataBase64, fpath );
        }
    }

    async viewPdf( fdataBase64: any, fpath: any )
    {
        //attempting to view pdf files
        const screen = window.screen as any;
        const left = screen.availLeft + (screen.availWidth / 2) - 500;
        const top = screen.availTop + (screen.availHeight / 2) - 350;
        const layout: any = new Layout();
        const pnl: any = new Panel();
        layout.add( pnl );
        pnl.fillHeight = true;
        pnl.fillRow = true;
        layout.fillHeight = true;
        layout.fillRow = true;

        const base64 = window.atob(fdataBase64);
        const len = new Array(base64.length);
        for (let i = 0; i < base64.length; i++)
            len[i] = base64.charCodeAt(i);
        const byteArray = new Uint8Array(len);
        const blob = new Blob([byteArray], { type: MimeTypes.PDF });
        let fileURL = URL.createObjectURL(blob);
        const viewPDF = document.createElement("object");
        fileURL += "#toolbar=0&navpanes=0";
        viewPDF.type = MimeTypes.PDF;
        viewPDF.data = fileURL;
        viewPDF.style.height = "100%";
        viewPDF.style.width = "100%";
        FileUtil.downloadBase64AsFile(fdataBase64, fpath);
        //Snackbar.showSnackbar("Downloaded " + fpath);
        pnl._element.appendChild(viewPDF);
        const props = { height: 1200, width: 850, panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } };
        const dlg: any = CommonDialogs.createDialog(layout, { title: "Viewing Pick Orders", okVisible: true, okDefault: false, ...props });
        const response = dlg.show();
    }

    private addMethodTotals(source: ModelRow, jobRow: ModelRow) {
        let pages = parseInt(jobRow.get("pages"));
        if (isNaN(pages)) {
            pages = 0;
        }
        if (jobRow.get("errors")?.length > 0) {
            if (jobRow.get("errors").endsWith(","))
                jobRow.set("errors", jobRow.get("errors").slice(0, -1));
            this.errorOrder++;
            this.errorPages += pages;
            return;
        }
        const pexp = parseInt(jobRow.get("printexpected"));
        const eexp = parseInt(jobRow.get("emailexpected"));
        const fexp = parseInt(jobRow.get("faxexpected"));
        const texp = parseInt(jobRow.get("ftpexpected"));
        const xexp = parseInt(jobRow.get("lgxexpected"));
        if (source.get("renp_print") === "Y" && pexp == 1 ) {
            this.printOrder++;
            this.printPages += pages;
        }
        if (source.get("renp_email") === "Y" && eexp == 1 ) {
            this.emailOrder++;
            this.emailPages += pages;
        }
        if (source.get("renp_fax") === "Y" && fexp == 1) {
            this.faxOrder++;
            this.faxPages += pages;
        }
        if (source.get("renp_ftp") === "Y" && texp == 1) {
            this.ftpOrder++;
            this.ftpPages += pages;
        }
        if( renlgxLicensed )
        {
            if (source.get("renp_x") === "Y" && xexp == 1) {
                this.lgxOrder++;
                this.lgxPages += pages;
            }
        }
    }

    /** This is an event handler for the onClick event of buttonProcess. */
    async buttonProcessOnClick(_event: ClickEvent) {
        if( this.fromPickList && this.stepperMain.selectedIndex == 0 )
        {
            this.fromPickList = false;
            CommonDialogs.showMessage("Failed to get pick info...");
            return;
        }
        const ids = [];
        this.reviewRows = [];
        for (const row of this.tableRenditionBilling.filteredRows) {
            if (row.data.get("selected") === "Y") {
                this.reviewRows.push(row.data);
                ids.push(row.data.get("renb_id"));
            }
        }
        if (ids.length === 0) {
            CommonDialogs.showMessage("Please select at least one row to process.");
        } else {
                this.procType = await this.getProcType();
                if( this.procType == null || this.selectedPrinter == null )
                    return;
                const selPrinter = this.selectedPrinter;
                this.sourceProcess.search({ request: "5", ids: ids, ErrorHandler: null, proctype: this.procType, selectedprinter: selPrinter }).then(() => {
                this.stepperMain.selectedIndex = 1;
            });
        }
    }

    async getProcType()
    {
        let procType=null;
        this.buttonProcess.busy = true;
        const panel = new Panel({ fillRow: true });
        panel.width = 200;
        //get printers list
        const items: DropdownItem[] = [];
        const rows: any[] = this.sourceImgdev.data;
        for (const row of rows) {
            const caption = row._data.imdv_port + " - " + row._data.imdv_comnt1;
            //items.push({ caption: caption });
            items.push(new DropdownItem( caption, caption ));
        }
        const printer = new Textbox({caption: "Select Printer"});
        printer.items = items;
        printer.allowDropdownBlank = false;
        printer.selectedItem = printer.items[0];
        //const pall = new Checkbox({ caption:"All", required: false, checked: true });
        const pprint = new Checkbox({ caption:"Print", required: false, checked: false });
        const pemail = new Checkbox({ caption:"Email", required: false, checked: false });
        const pfax = new Checkbox({ caption:"Fax", required: false, checked: false });
        const pftp = new Checkbox({ caption:"Ftp", required: false, checked: false });
        const plgx = new Checkbox({ caption:"Lgx", required: false, checked: false });
        const hzsp = new HorizontalSpacer({});
        hzsp.fillRow = true;
        hzsp.height = 10;
        const okpb = new Button({ caption: "Process" });
        okpb.cancel = false;
        okpb.rowBreak = false;
        okpb.color = "primary";
        okpb.backgroundColor = "primary.reverse";
        const w: any= panel.width;
        okpb.width = w/2;
        okpb.addClickListener(() => {
            if (dlg.validateSimple())
                dlg.close(true);
        });
        const cancelpb = new Button({ caption: "Cancel" });
        cancelpb.cancel = true;
        cancelpb.color = "primary.reverse";
        cancelpb.backgroundColor = "primary";
        cancelpb.width = w/2;
        cancelpb.addClickListener(() => {
            if (dlg.validateSimple())
                dlg.close(false);
        });
        panel.add(printer);
        //panel.add(pall);
        panel.add(pprint);
        panel.add(pemail);
        //panel.add(pfax);
        panel.add(pftp);
        if( renlgxLicensed )
            panel.add(plgx);
        panel.add(okpb);
        panel.add(hzsp);
        panel.add(cancelpb);

        const props = { width: 200, panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } };
        const dlg = CommonDialogs.createDialog(panel, {title: "Select Process Type", okVisible: false, ...props });
        //dlg.backgroundColor = "primary";
        //dlg.title.color = "primary.reverse";
        const response = await dlg.show();
        if ( response == true )
        {
            procType = "";
            //if( pall.checked )
            //    procType = "PEFT";
            //else
            //{
                if( printer.selectedItem != null )
                {
                    //const s = printer.selectedItem.caption;
                    const s = printer.selectedItem.displayValue;
                    const end = s.indexOf("-")-1;
                    this.selectedPrinter = s.substring(0,end);
                }
                if( pprint.checked )
                    procType += "P";
                if( pemail.checked )
                    procType += "E";
                if( pfax.checked )
                    procType += "F";
                if( pftp.checked )
                    procType += "T";
                if( renlgxLicensed )
                {
                    if( plgx.checked )
                        procType += "X";
                }
            //}
            if( procType == "" )
                procType = null;
        }
        this.buttonProcess.busy = false;
        return( procType );
    }


    /** This is an event handler for the onDataDisplay event of textboxRenbInvno. */
    textboxRenbInvnoOnDataDisplay(event: DataDisplayEvent) {
        const invno = event.rowData.get("renb_ccinvno");
        if (invno == null) {
            (event.target as Textbox).caption = "Summary invoice number";
            (event.target as Textbox).text = event.rowData.get("renb_invno");
        }
    }

    /** This is an event handler for the beforeStepListener event of stepperMain. */
    stepperMainBeforeStepListener(event: StepEvent) {
        if (event.newIndex === 1 && this.sourceProcess.data.length === 0) {
            this.buttonProcessOnClick(null);
            event.preventDefault();
        }
    }

    private getDeliveryMethods(source: ModelRow, jobRow: ModelRow): string {
        const pexp = parseInt(jobRow.get("printexpected"));
        const eexp = parseInt(jobRow.get("emailexpected"));
        const fexp = parseInt(jobRow.get("faxexpected"));
        const texp = parseInt(jobRow.get("ftpexpected"));
        const xexp = parseInt(jobRow.get("lgxexpected"));
        const methods = [];
        if (source.get("renp_print") === "Y" && pexp == 1) {
            methods.push("Print");
        }
        if (source.get("renp_email") === "Y" && eexp == 1) {
            methods.push("Email");
        }
        if (source.get("renp_fax") === "Y" && fexp == 1) {
            methods.push("Fax");
        }
        if (source.get("renp_ftp") === "Y" && texp == 1) {
            methods.push("FTP");
        }
        if( renlgxLicensed )
        {
            if (source.get("renp_x") === "Y" && xexp == 1) {
                methods.push("LGX");
            }
        }
        return methods.join(", ");
    }

    private toggleAll() {
        const checked = this.checkboxSelectAll.checked;
        for (const row of this.sourceRenditionBilling.data) {
            row.set("selected", checked ? "Y" : "N");
        }
        //this.tableRenditionBilling._applyFilter();
        this.tableRenditionBilling.applyFilters();
    }

    /** This is an event handler for the onDataDisplay event of labelMissing. */
    labelMissingOnDataDisplay(event: DataDisplayEvent) {
        (event.target as Label).imageName = event.rowData.get("missing") === "Y" ? "circleWarning" : null;
    }

    /** This is an event handler for the afterExecution event of sourceRenditionBilling. */
    sourceRenditionBillingAfterExecution(event: DataSourceExecutionEvent) {
        this.checkboxSelectAll.checked = true;
        this.toggleAll();
    }

    /** This is an event handler for the onClick event of buttonCommit. */
    async buttonCommitOnClick(event: ClickEvent) {
        this.buttonCommit.busy = true;
        try {

            await Api.post("rendition-billing/commit", { job_number: this.labelJobNumber.text, proctype: this.procType });
            (this.layoutMonitor as RenditionMonitor).showJob(parseInt(this.labelJobNumber.text));
            this.stepperMain.selectedIndex = 2;
        } finally {
            this.buttonCommit.busy = false;
        }
    }

    /** This is an event handler for the onDataDisplay event of textboxRenbBillTo. */
    textboxRenbBillToOnDataDisplay(event: DataDisplayEvent) {
        // this can be much removed if we took the time to set up the proper metadata and lookup model
        const textbox = event.target as Textbox;
        const billto = event.rowData.get("renb_bill_to");
        textbox.caption = "Customer: " + billto;
        textbox.tooltipCallback = async () => {
            const layout = Layout.getLayout("imaging/LookupInvoice") as LookupInvoice;
            await layout.ensureLoaded();
            const invoice = event.rowData.get("renb_ccinvno");
            if (StringUtil.isEmptyString(invoice)) {
                return textbox.showTooltip("No invoice number for this record.");
            }
            await layout.mainDataSource.search({ invoice_no_string: invoice });
            layout.backgroundColor = "transparent";
            const wrapper = new Panel({ width: 500, height: 340 });
            wrapper.add(layout);
            if (layout.mainDataSource.data.length === 0) {
                 return textbox.showTooltip("Invoice " + invoice + " not found.");
            } else {
                return textbox.showTooltip(wrapper, null, { themeKey: "quickInfo", color: null });
            }
        }
    }

    /** This is an event handler for the onRowExpand event of tableRenditionBilling. */
    async tableRenditionBillingOnRowExpand(event: TableRowExpansionEvent) {
        const layout = event.expandComponents[0] as LookupInvoice;
        await layout.ensureLoaded();
        const ccinvno = event.getTableRow().data.get("renb_ccinvno");
        const custid = event.getTableRow().data.get("renb_bill_to");
        const oid = event.getTableRow().data.get("renb_load_no");
        if( ccinvno )
            await layout.mainDataSource.search({ invoice_no_string: ccinvno });
        if( custid && oid && layout.mainDataSource.rowCount == 0 )
        {
            await layout.mainDataSource.search({ customer_id: custid, order_id: oid });
            if( layout.mainDataSource.rowCount == 0 )
                await layout.mainDataSource.search({ customer_id: custid });
            if( layout.mainDataSource.rowCount > 1 )
               layout.textboxAmount.text = "";
        }
    }

    /** This is an event handler for the beforeExecution event of sourceRenditionBilling. */
    sourceRenditionBillingBeforeExecution(event: DataSourceExecutionEvent) {
        //this.sourceRenditionBilling.orderBy = ["renb_invno", "renb_bill_to", "renb_load_no"];
        this.sourceRenditionBilling.orderBy = [{field: "renb_invno", sort: "asc" },
                                            {field: "renb_bill_to", sort: "asc" },
                                            {field: "renb_load_no", sort: "asc" }];
    }

/** This is an event handler for the onClick event of buttonButton1. */
  async buttonPickOnClick(event: ClickEvent) {
    //const screen = window.screen as any;
    //const left = screen.availLeft + (screen.availWidth / 2) - 500;
    //const top = screen.availTop + (screen.availHeight / 2) - 350;
    //const openedWindow = await Navigation.navigateTo("imaging/RenditionPickList", { newTab: true, left, top, height: 700, width: 1000, windowDecorators: false });
    //load all renbill records
    this.buttonPick.busy = true;
    this.sourceRenditionBilling.search({ /*renb_done: "N", renb_submitted: "N", renb_billtype: "F"*/ });
    const pl: any = Layout.getLayout( "imaging/RenditionPickList" ) as RenditionPickList;
    const ids = [];

    const props = { height: 600, width: 800, panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } };
    const dlg = CommonDialogs.createDialog(pl, { title: "Enter Orders to View", okVisible: true, okDefault: false, ...props });
    dlg.okButtonCaption = "Process";
    const response = await dlg.show();
    const table1:any = pl.table1;
    if (response != undefined && table1.rowCount > 0 )
    {
        //console.log("pickListClose");
        const viewType = pl.viewType;
        const procType = "E";
        const selPrinter = "imp";
        //console.log(table1.rowCount);
        this.reviewRows = [];
        for (let i = 0; i < table1.rowCount; i++)
        {
            const order = table1.rows[i].data.renb_load_no;
            const billto = table1.rows[i].data.renb_bill_to;
            const id = table1.rows[i].data.renbid;
            for (const row of this.tableRenditionBilling.filteredRows)
            {
                const rorder = row.data.get("renb_load_no");
                const rbillto = row.data.get("renb_bill_to");
                const rid = row.data.get("renb_id");
                //console.log( "rorder:" + rorder + " rbillto:" + rbillto + " rid:" + rid );
                if (rorder === order && rbillto === billto && rid == id )
                {
                    this.reviewRows.push(row.data);
                    ids.push( id );
                    break;
                }
            }
            //ids.push( id );
        }
        if (ids.length > 0)
        {
            this.pickListProcess( ids, procType, selPrinter, viewType );
        }
    }
    else    //reload original renbill recordds
        this.sourceRenditionBilling.search({ renb_done: "N", renb_submitted: "N", renb_billtype: "F" });
    this.buttonPick.busy = false;
  }

  public pickListProcess( ids: any, procType: any, selPrinter: any, viewType: any )
  {
      if (ids.length === 0) {
          CommonDialogs.showMessage("Please select at least one row to process.");
      } else {
              this.fromPickList = true;
              const resp: any = this.sourceProcess.search({ request: "6", ids: ids, ErrorHandler: null, proctype: procType, selectedprinter: selPrinter, viewtype: viewType }).then(() => {
              this.stepperMain.selectedIndex = 1;
          });
      }
  }

}
